import Base from './Base';

export default class Client extends Base {
    constructor(item) {
        super(item);

        this.groups = Array.isArray(item.groups) ? item.groups : [];
    }

    get hasSubscription() {
        return Boolean(this.subscriptions.length);
    }

    get hasOrganizationNumber() {
        return Boolean(this.owner.organization_number);
    }

    get subscription() {
        return this.subscriptions[0];
    }

    get subscriptionPlanName() {
        if (!this.hasSubscription) return '-';
        if (
            this.subscriptionPlanId === 'free-plan-trial' ||
            this.subscriptionPlanId === 'free-plan-monthly'
        ) return 'Pay-As-You-Go';

        return this.subscription.plan.name;
    }

    get subscriptionPlanId() {
        if (!this.hasSubscription) return '-';

        return this.subscription.plan.id;
    }

    get organizationFormattedNumber() {
        if (!this.hasOrganizationNumber) return '-';

        return this.owner.organization_number.formatted_number;
    }

    get ownerEmail() {
        if (!this.hasProfile) return '-';

        return this.owner.profile.email;
    }

    get hasProfile() {
        return Boolean(this.owner?.profile);
    }

    get organisationName() {
        return this.name ?? '-';
    }

    get hubSpotTeams() {
        if (!this.groups.length) return null;

        return this.groups.map((item) => item.name);
    }
}
